import {Clock} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

import {startWorkLoader, workTimeHistoryLoader} from './loaders';

// Standalone, outside RootPage (no menu chrome) — gates entry to the app
// before the user has access, so it's rendered at the router's top level.
export const preAccessRoutes = [
  {
    path: '/work-time/start',
    loader: startWorkLoader,
    async lazy() {
      const {StartWorkPage} = await import('./pages/StartWorkPage');
      return {element: <StartWorkPage />};
    },
  },
] as RouteObject[];

// Nested under RootPage (has the app menu chrome) once the user has access.
// The admin overview is exposed as the feature's menu entry.
export const postAccessRoutes = [
  {
    path: 'work-time',
    loader: protectedLoader('WORK_TIME', 'MANAGE_WORK_TIME'),
    async lazy() {
      const {WorkTimePage} = await import('./pages/WorkTimePage');
      return {element: <WorkTimePage />};
    },
  },
] as RouteObject[];

// Nested under RootPage but reachable before work starts, so employees can
// check their own history from the start work page.
export const anyAccessRoutes = [
  {
    path: 'work-time/history',
    loader: workTimeHistoryLoader,
    async lazy() {
      const {MyWorkTimePage} = await import('./pages/MyWorkTimePage');
      return {element: <MyWorkTimePage />};
    },
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/work-time',
    text: i18n.t('Work time'),
    icon: <Clock />,
    permission: 'MANAGE_WORK_TIME',
    entitlement: 'WORK_TIME',
  },
] as MenuItemElement[];
